import * as Immutable from "immutable";
import Parameter from "views/logic/parameters/Parameter";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
const _ValueParameter = class _ValueParameter extends Parameter {
  constructor(name, title, description, dataType, defaultValue, optional, binding) {
    super(_ValueParameter.type, name, title, description, dataType, defaultValue, optional, binding);
  }
  static create(name, title, description, dataType, defaultValue, optional, binding) {
    return new _ValueParameter(name, title, description, dataType, defaultValue, optional, binding);
  }
  toBuilder() {
    const { type, name, title, description, dataType, defaultValue, optional, binding } = this._value;
    return new Builder(Immutable.Map({ type, name, title, description, dataType, defaultValue, optional, binding }));
  }
  toJSON() {
    const { type, name, title, description, dataType, defaultValue, optional, binding } = this._value;
    return {
      type,
      name,
      title,
      description,
      data_type: dataType,
      default_value: defaultValue,
      optional,
      binding: binding ? binding.toJSON() : void 0
    };
  }
  static fromJSON(value) {
    const { name, title, description, data_type, default_value, optional, binding } = value;
    return new _ValueParameter(
      name,
      title,
      description,
      data_type,
      default_value,
      optional,
      ParameterBinding.fromJSON(binding)
    );
  }
  static builder() {
    return new Builder().type(_ValueParameter.type).optional(false).dataType("any").binding(ParameterBinding.empty());
  }
};
_ValueParameter.type = "value-parameter-v1";
let ValueParameter = _ValueParameter;
export {
  ValueParameter as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  name(value) {
    return new Builder(this.value.set("name", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  description(value) {
    return new Builder(this.value.set("description", value));
  }
  dataType(value) {
    return new Builder(this.value.set("dataType", value));
  }
  defaultValue(value) {
    return new Builder(this.value.set("defaultValue", value));
  }
  optional(value) {
    return new Builder(this.value.set("optional", value));
  }
  binding(value) {
    return new Builder(this.value.set("binding", value));
  }
  build() {
    const { name, title, description, dataType, defaultValue, optional, binding } = this.value.toObject();
    return new ValueParameter(name, title, description, dataType, defaultValue, optional, binding);
  }
}
ValueParameter.Builder = Builder;
